import { Button, HStack, ModalProps, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAccount, useDisconnect } from 'wagmi';
import config from '../constants/config';
import useHoneyShots from '../hooks/useHoneyShots';
import useTranslate from '../hooks/useTranslate';
import useWalletAssets from '../hooks/useWalletAssets';
import BnbIcon from '../components/BnbIcon';
import CopyInput from '../components/CopyInput';
import EtherAmount from '../components/EtherAmount';
import HoneyShotIcon from '../components/HoneyShotIcon';
import SimplePopup from '../components/SimplePopup';
import TinyHeading from '../components/TinyHeading';
import WalletAsset from '../components/WalletAsset';

type WalletPopupProps = Omit<ModalProps, 'children'>;

const WalletPopup = (props: WalletPopupProps) => {
  const navigate = useNavigate();
  const translate = useTranslate();
  const { address } = useAccount();
  const { balance } = useWalletAssets();
  const { honeyShotsBalance } = useHoneyShots();
  const { disconnect } = useDisconnect();

  const handleDisconnect = () => {
    disconnect();
    navigate('/');
  };

  return (
    <SimplePopup size="sm" title={translate('walletPopup:title')} {...props}>
      <CopyInput value={address || ''} mt="6" mb="6" />

      <VStack spacing="2px" mb="6">
        <WalletAsset
          py="4"
          icon={BnbIcon}
          value={<EtherAmount amount={balance} />}
        >
          <HStack pr="3">
            <TinyHeading>BNB</TinyHeading>

            <Button
              as="a"
              href={config.urls.buyBnbUrl}
              target="_blank"
              size="xs"
              variant="outline"
            >
              {translate('common:buy')}
            </Button>
          </HStack>
        </WalletAsset>

        <WalletAsset py="4" icon={HoneyShotIcon} value={honeyShotsBalance}>
          <HStack pr="3">
            <TinyHeading>Honey Shots</TinyHeading>
            <Button
              as="a"
              href={config.urls.nftCollectionUrl}
              target="_blank"
              size="xs"
              variant="outline"
            >
              {translate('common:buy')}
            </Button>
          </HStack>
        </WalletAsset>
      </VStack>

      <Button
        onClick={handleDisconnect}
        variant="solid"
        colorScheme="dark"
        w="full"
      >
        {translate('common:disconnect')}
      </Button>
    </SimplePopup>
  );
};

export default WalletPopup;
